import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'orderBy', pure: false, standalone: false })
export class OrderByPipe implements PipeTransform {
  value: any = [];

  public static _orderByComparator(a: any, b: any): number {
    if ((a === null || a === undefined) && (b === null || b === undefined)) {
      return 0;
    }

    if (a === null || a === undefined) {
      a = isNaN(parseFloat(b)) || !isFinite(b) ? '' : 0;
    }

    if (b === null || b === undefined) {
      b = isNaN(parseFloat(a)) || !isFinite(a) ? '' : 0;
    }

    if (
      isNaN(parseFloat(a)) ||
      !isFinite(a) ||
      isNaN(parseFloat(b)) ||
      !isFinite(b)
    ) {
      if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) {
        return -1;
      }
      if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) {
        return 1;
      }
    } else {
      if (parseFloat(a) < parseFloat(b)) {
        return -1;
      }
      if (parseFloat(a) > parseFloat(b)) {
        return 1;
      }
    }

    return 0;
  }

  transform(input: any, config: any = ['+']): any {
    if (!input) {
      return input;
    }

    this.value = [...input];
    const value = this.value;

    if (!Array.isArray(value)) {
      return value;
    }

    if (
      !Array.isArray(config) ||
      (Array.isArray(config) && config.length === 1)
    ) {
      const propertyToCheck: string = !Array.isArray(config)
        ? config
        : config[0];
      const desc = propertyToCheck.substr(0, 1) === '-';

      if (
        !propertyToCheck ||
        propertyToCheck === '-' ||
        propertyToCheck === '+'
      ) {
        if (!desc) {
          return value.toSorted((a, b) => a-b );
        }
      } else {
        const property: string =
          propertyToCheck.substr(0, 1) === '+' ||
            propertyToCheck.substr(0, 1) === '-'
            ? propertyToCheck.substr(1)
            : propertyToCheck;

        return value.sort(function (a: any, b: any) {
          let aValue = a[property];
          let bValue = b[property];

          const propertySplit = property.split('.');

          if (
            typeof aValue === 'undefined' &&
            typeof bValue === 'undefined' &&
            propertySplit.length > 1
          ) {
            aValue = a;
            bValue = b;
            for (let j = 0; j < propertySplit.length; j++) {
              aValue = aValue[propertySplit[j]];
              bValue = bValue[propertySplit[j]];
            }
          }

          return !desc
            ? OrderByPipe._orderByComparator(aValue, bValue)
            : -OrderByPipe._orderByComparator(aValue, bValue);
        });
      }
    } else {
      return value.sort(function (a: any, b: any) {
        for (let i: number = 0; i < config.length; i++) {
          const desc = config[i].substr(0, 1) === '-';
          const property =
            config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
              ? config[i].substr(1)
              : config[i];

          let aValue = a[property];
          let bValue = b[property];

          const propertySplit = property.split('.');

          if (
            typeof aValue === 'undefined' &&
            typeof bValue === 'undefined' &&
            propertySplit.length > 1
          ) {
            aValue = a;
            bValue = b;
            for (let j = 0; j < propertySplit.length; j++) {
              aValue = aValue[propertySplit[j]];
              bValue = bValue[propertySplit[j]];
            }
          }

          const comparison = !desc
            ? OrderByPipe._orderByComparator(aValue, bValue)
            : -OrderByPipe._orderByComparator(aValue, bValue);

          if (comparison !== 0) {
            return comparison;
          }
        }

        return 0;
      });
    }
  }
}

export const ORDERBY_PROVIDERS = [OrderByPipe];
